import { render } from "./EditInfoFooter.vue?vue&type=template&id=e0134948&ts=true"
import script from "./EditInfoFooter.vue?vue&type=script&lang=ts"
export * from "./EditInfoFooter.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__